import Vue from 'vue';
import Moment from 'moment-jalaali';
import UserService from "./services/UserService";

Vue.prototype.getJalaliDate = (date, format = 'jYYYY-jMM-jDD HH:mm') => {
    if(date === 'now') return Moment().format(format);
    return date ? Moment(date).format(format) : 'نامشخص';
};

Vue.prototype.userCan = permission => UserService.getPermissions().indexOf(permission)  > -1;

